import { defineStore } from 'pinia';
import { ref, toRaw } from 'vue';
import type { AppSettings } from '../types';
import { loadSettings, saveSettings } from '../db';

export const useSettingsStore = defineStore('settings', () => {
  const settings = ref<AppSettings>({
    pushEnabled: false,
    pushSubscription: null,
    serverUrl: import.meta.env.VITE_SERVER_URL ?? '',
    notifyMinutesBefore: 0,
    theme: 'dark',
  });

  async function load(): Promise<void> {
    settings.value = await loadSettings();
    applyTheme();
  }

  async function save(patch: Partial<AppSettings>): Promise<void> {
    settings.value = { ...settings.value, ...patch };
    await saveSettings({ ...toRaw(settings.value) });
    applyTheme();
  }

  function applyTheme(): void {
    const root = document.documentElement;
    if (settings.value.theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
    try {
      localStorage.setItem('aniping-theme', JSON.stringify(settings.value.theme));
    } catch {
      /* private mode etc — fine to ignore, IndexedDB is source of truth */
    }
  }

  return {
    settings,
    load,
    save,
  };
});
